export default __webpack_public_path__ + "assets/6e757db5918d0f34.jpg";